import React from "react"
import autobind from "class-autobind"
import AccountStore from "../../../stores/AccountStore"
import { IHierarchyItem, IRecord, IRecordSearch, ERecordSearchFilter, ERecordPageType, IDateRange, EDayOfWeek } from "../../../models"
import * as api from "../../../api"
import Records from "../../../components/record/Records"
import HierarchyRecordPunchExport from "../../../components/record/HierarchyRecordPunchExport"
import * as utils from "../../../helpers/utils"
import * as timeHelper from "../../../helpers/timeHelper"
import moment from "moment"
interface IProps {
	hierarchyItem: IHierarchyItem
	readonly: boolean
}
interface IState {
	selectedFilter: ERecordSearchFilter
	loading: boolean
	records: IRecord[]
	offset: number
	limit: number
	total: number
	showExceptionDailog: boolean
	exceptionPunchId: string
	exceptionType: string
	dateRange: IDateRange
}

export default class HierarchyRecords extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		const storedRecordSelectedFilter = utils.getCookie("HierarchyRecordSelectedFilter") as ERecordSearchFilter
		const thisWeek = timeHelper.getWeekRange(EDayOfWeek.Monday, moment())
		this.state = {
			selectedFilter: storedRecordSelectedFilter || ERecordSearchFilter.All,
			loading: true,
			records: [],
			offset: 0,
			limit: 20,
			total: 0,
			showExceptionDailog: false,
			exceptionPunchId: null,
			exceptionType: null,
			dateRange: { StartDate: thisWeek.startDate, EndDate: thisWeek.endDate }
		}
		autobind(this)
	}
	componentDidMount() {
		this.getRecords()
	}

	componentWillReceiveProps(nextProps) {
		this.props.hierarchyItem.Id !== nextProps.hierarchyItem.Id && this.getRecords()
	}

	getRecords() {
		this.setState({ loading: true }, () =>
			api.getRecords(AccountStore.getCurrentAccount().Id, this.state.offset / this.state.limit, this.state.limit, moment(this.state.dateRange.StartDate).utc(true).format(), moment(this.state.dateRange.EndDate).utc(true).format(), this.props.hierarchyItem.Id, false, this.state.selectedFilter).then(res => {
				const result: IRecordSearch = res.data
				this.setState({
					records: result.Documents,
					total: result.TotalDocumentCount,
					loading: false,
				})
			})
		)
	}

	render() {
		return (
			<div style={{ position: "relative", marginTop: -25 }}>
				<HierarchyRecordPunchExport />
				<Records
					loading={this.state.loading}
					pageMode={ERecordPageType.Hierarchy}
					selectedFilter={this.state.selectedFilter}
					dateRange={this.state.dateRange}
					total={this.state.total}
					offset={this.state.offset}
					limit={this.state.limit}
					limitOptions={[20, 50, 100]}
					records={this.state.records}
					onPageClick={offset => this.setState({ offset }, () => this.getRecords())}
					onLimitChange={limit => this.setState({ limit, offset: 0 }, () => this.getRecords())}
					handleChangeSelectedFilter={selectedFilter => {
						localStorage.setItem("findd_HierarchyRecordSelectedFilter", selectedFilter)
						this.setState({ selectedFilter, offset: 0 }, () => this.getRecords())
					}}
					handleChangeDateRange={dateRange => {
						this.setState({ dateRange, offset: 0 }, () => this.getRecords())
					}}
					reload={initOffset => initOffset ?
						this.setState({ offset: 0 }, () => this.getRecords()) :
						this.getRecords()
					}
				/>
			</div>
		)
	}
}
